module.exports = {
	proxyUrl: 'zeepkistenrace.test',
	port: 3000,
	barbaEnabled: false,
	wrapperID: 'app',
	viewClass: 'view',
	analytics_key: false,
};

